import { render, staticRenderFns } from "./side-nav-franchise.vue?vue&type=template&id=30fbaba6&scoped=true"
import script from "./side-nav-franchise.vue?vue&type=script&lang=js"
export * from "./side-nav-franchise.vue?vue&type=script&lang=js"
import style0 from "./side-nav-franchise.vue?vue&type=style&index=0&id=30fbaba6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30fbaba6",
  null
  
)

export default component.exports